import { render } from "./DebriyajRulmani.vue?vue&type=template&id=1f1c42be"
import script from "./DebriyajRulmani.vue?vue&type=script&lang=js"
export * from "./DebriyajRulmani.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__